import { CSSObject } from "@emotion/react";
import { constants, mediaQueryStyles } from "@newsela/angelou";

const { ui } = constants.colors;
const { mediaQuery: breakpoint } = mediaQueryStyles;

export const inputsGridContainerCss: CSSObject = {
  maxWidth: "40.75rem",
  display: "grid",
  gridTemplateColumns: "1fr 1fr 1fr 1fr",
  columnGap: "0.5rem",
  [breakpoint.upTo("xs")]: {
    width: "auto",
    gridTemplateColumns: "1fr",
  },
};

export const gridWideInputWrapperCss: CSSObject = {
  maxWidth: "20.125rem",
  gridColumn: "span 2",
  [breakpoint.upTo("xs")]: {
    gridColumn: "unset",
    minWidth: "18rem",
    maxWidth: "unset",
    width: "100%",
  },
};

export const resetPasswordButtonCss: CSSObject = {
  height: "3rem",
  alignSelf: "center",
  width: "9.0625rem",
  backgroundColor: ui.core[700],
  [breakpoint.upTo("xs")]: {
    marginTop: "1.75rem",
    width: "100%",
  },
};
